import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'order'
  },
  {
    path: '/order',
    name: 'orderDetails',
    component: () => import('@/views/orderDetails/index.vue')
  },
  {
    path: '/normalExtension',
    name: 'defaultRepayment',
    component: () => import('@/views/defaultRepayment/index.vue')
  },
  {
    path: '/splitRepayment',
    name: 'splitRepayment',
    component: () => import('@/views/defaultRepayment/components/splitRepayment.vue')
  },
  {
    path: '/repaymentExtension',
    name: 'extensionRepayment',
    component: () => import('@/views/extensionRepayment/index.vue')
  },
  {
    path: '/repaymentThirdParty',
    name: 'repaymentThirdParty',
    component: () => import('@/views/repaymentThirdParty.vue')
  },
  {
    path: '/agreementPage',
    name: 'agreementPage',
    component: () => import('@/views/agreementPage.vue')
  },
  {
    path: '/wallet',
    name: 'walletPage',
    component: () => import('@/views/wallet/index.vue')
  },
  {
    path: '/transactionList',
    name: 'transactionList',
    component: () => import('@/views/wallet/transactionList.vue')
  },
  {
    path: '/transactionDetail',
    name: 'transactionDetail',
    component: () => import('@/views/wallet/transactionDetail.vue')
  },
  {
    path: '/withdrawalStatus',
    name: 'withdrawalStatus',
    component: () => import('@/views/wallet/withdrawalStatus.vue')
  },
  {
    path: '/withdrawalApply',
    name: 'withdrawalApply',
    component: () => import('@/views/wallet/withdrawalApply.vue')
  },
  {
    path: '/walletRepayment',
    name: 'walletRepayment',
    component: () => import('@/views/wallet/repayment.vue')
  },
  {
    path: '/walletRepaymentSuccess',
    name: 'walletRepaymentSuccess',
    component: () => import('@/views/wallet/repaymentSuccess.vue')
  },
  {
    path: '/walletPayment',
    name: 'walletPayment',
    component: () => import('@/views/wallet/payment.vue')
  },
  {
    path: '/walletPaymentSuccess',
    name: 'walletPaymentSuccess',
    component: () => import('@/views/wallet/paymentSuccess.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
